import { namespace } from 'wsm-tagging-utils';
import findPropertiesFromSelector from '../../../../findPropertiesFromSelector';
import linkTypeSelectors from '../mappings/linkTypeSelectors';

const runLinkTypeDecorator = (win) => {
	namespace(win, 'DDC.tracking.shift.decorators');

	const {
		DDC: { tracking }
	} = win;

	// ======================================================================
	// ---------------------------- Constructor -----------------------------
	// ======================================================================

	/**
	 * The Link Type Decorator updates link click events with the type of the
	 * link clicked and applies the type to the event to be used by event handlers.
	 *
	 * @param {Object} window The window object
	 * @param {tracking.framework.runtime.Page} page A Page instance for page related queries
	 * @param {tracking.framework.runtime.EventHandler} delegate The EventHandler implementation to which all interface operations are delegated
	 * @constructor
	 */
	tracking.shift.decorators.LinkTypeDecorator =
		tracking.shift.decorators.LinkTypeDecorator ||
		(function buildLinkTypeDecorator() {
			// ======================================================================
			// ---------------------------- Constructor -----------------------------
			// ======================================================================
			const LinkTypeDecorator = class extends tracking.framework.runtime
				.EventHandlerDecorator {};

			LinkTypeDecorator.prototype.logCategory =
				'ws-tagging:LinkTypeDecorator';

			// ======================================================================
			// --------------------------- Event Handlers ---------------------------
			// ======================================================================

			/**
			 * Provides supplementary functionality for the link click handler.
			 *
			 * @param {Object} eventData The event data object.
			 *
			 * Relevant eventData properties:
			 * {string} text Text on link
			 * {string} url The URL listed on "href"
			 * {string} pageName The name of the current page
			 * {Object} element A reference to the element clicked
			 */
			LinkTypeDecorator.prototype.handleLinkClick =
				function handleLinkClick(eventData) {
					const { events, type } =
						findPropertiesFromSelector(
							linkTypeSelectors,
							eventData.element
						) || {};

					this.delegate.handleLinkClick({
						...eventData,
						...(!eventData.linkType &&
							type && {
								linkType: type
							}),
						...(events && {
							linkEvents: events
						})
					});
				};

			return LinkTypeDecorator;
		})();
};

export default runLinkTypeDecorator;
